import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { DfAccountModule } from '@df/account/df-account.module';
export function provideAccount(): EnvironmentProviders {
    return makeEnvironmentProviders([
        importProvidersFrom(
            DfAccountModule.forRoot({
                navigation: [
                    { icon: 'basket', label: 'Order history', link: '/account/my-orders', mobileLabel: 'Orders history' },
                    { icon: 'account', label: 'Account details', link: '/account/edit' },
                    { icon: 'home', label: 'Address book', link: '/account/address-book' },
                    { icon: 'payment', label: 'Payment methods', link: '/account/payment-methods' },
                    {
                        label: 'Wishlist',
                        link: '/account/wishlist',
                        icon: 'wishlist',
                        mobileLabel: 'Your wishlist'
                    },
                    { label: 'Marketing preferences', link: '/account/marketing-preferences', icon: 'settings' }
                ],
                historyLoadQty: 1
            })
        )
    ]);
}
